import { Typography } from "antd";

function CustomInfoAdress({ value }) {
  return (
    <Typography.Text>
      {[value?.address, value?.ward?.name, value?.district?.name, value?.city?.name].filter(Boolean).join(" - ") ||
        "---"}
    </Typography.Text>
  );
}

export default CustomInfoAdress;
